import { LocationConfig } from './LocationConfig';
import { LocationService } from './LocationService';
export function viewerLocationPlugin(flowApi) {
  return function (router) {
    const {
      controllerConfig: {
        wixCodeApi
      }
    } = flowApi;
    const configuration = new LocationConfig(wixCodeApi.location);
    const service = new LocationService(wixCodeApi.location);
    router.locationConfig = configuration;
    router.locationService = service;
    return {
      name: 'WixUIRouterViewerLocation',
      dispose(router) {
        router.dispose(configuration);
        router.dispose(service);
      }
    };
  };
}
//# sourceMappingURL=plugin.js.map